import api from '@/api'

const product = {
  state: {
    total: 0,
    products: [],
    currentProduct: null
  },

  mutations: {
    SET_PRODUCTS (state, { total = 0, products }) {
      state.total = total
      state.products = products
    },

    SET_CURRENT_PRODUCT (state, { product }) {
      state.currentProduct = product
    }
  },

  actions: {
    createProduct ({ commit }, data) {
      return api.product.createProduct(data)
    },

    deleteProduct ({ commit }, data) {
      return api.product.deleteProduct(data)
    },

    updateProduct ({ commit }, data) {
      return api.product.updateProduct(data)
    },

    getProducts ({ commit }, data) {
      return api.product.getProducts(data).then(response => {
        commit('SET_PRODUCTS', response.data)
        return response
      })
    },

    getProductById ({ commit }, data) {
      return api.product.getProductById(data).then(response => {
        // commit('SET_CURRENT_PRODUCT', response.data)
        return response
      })
    }

  }
}

export default product
